export const getMaskedAccountNumber = (str: string | undefined): string | undefined => {
  if (!str) {
    return;
  }

  return `*${str}`.replace(/[^\d*]|\*(?=)/gu, '');
};

export const parseUUIDFromStringWithKey = (str: string | undefined, key: string): string | null => {
  if (!str) {
    return null;
  }

  const uuidRegex = new RegExp(`${key}=([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})`);

  const match = str.match(uuidRegex);
  return match && match[1];
};

export const parseLinkedAccountIds = (str: string | undefined): string[] => {
  if (!str) {
    return [];
  }

  const linkedIdsRegex = /linkedIds=([^&]+)/;
  const match = str.match(linkedIdsRegex);

  if (!match || !match[1]) {
    return [];
  }

  return match[1].split(',').filter((id) => id.trim().length > 0);
};
